/*
 * /dev (page)
 */
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router"
import { RuntimeDetailsCard, useDevMode } from "@emr/dev"
import { ThemeToggle } from "@emr/theme"
import {
	Button,
	Container,
	Header,
	Page,
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from "@emr/react-ui"
import { useEffect, useState } from "react"
import { DevStylingTab } from "../components/dev/dev-styling.tab"

export const Route = createFileRoute("/dev")({ component: DevPage })

function DevPage() {
	const [crash, setCrash] = useState(false)

	const { devMode, setDevMode } = useDevMode()
	const navigate = useNavigate()

	useEffect(() => {
		if (crash) {
			throw new Error("DevPage: Simulated crash!")
		}
	}, [crash])

	function onDisableDevModeClick() {
		setDevMode(false)
		navigate("/" as any)
	}

	if (!devMode) {
		return null
	}

	const tab = "runtime"

	const links: any[] = [
		{ label: "Home", url: "/" },
		{ label: "About", url: "/about" },
		{ label: "Auth", url: "/auth" },
		{ label: "Privacy Policy", url: "/legal/privacy-policy" },
		{ label: "Cookie Policy", url: "/legal/cookie-policy" },
		{ label: "Terms and Conditions", url: "/legal/terms-and-conditions" },
	]

	return (
		<Page centerVertical={false}>
			<Container width={"lg"} padding={"lg"} gap={"sm"}>
				<Header>Dev Portal</Header>
				<section className={"flex flex-col gap-2"}>
					<h5>Actions</h5>
					<div className={"flex flex-wrap gap-2"}>
						<Button variant={"destructive"} onClick={onDisableDevModeClick}>
							Disable Dev Mode
						</Button>
						<ThemeToggle />
						<Button variant={"destructive"} onClick={() => setCrash(true)}>
							Trigger Crash
						</Button>
					</div>
				</section>
				<section className={"flex flex-col gap-2"}>
					<h5>Links</h5>
					<div className={"flex flex-wrap gap-2"}>
						{links.map(({ label, url }, index: number) => (
							<Link to={url} key={index}>
								<Button variant={"default"}>{label}</Button>
							</Link>
						))}
					</div>
				</section>
				<div>
					<Tabs className={"w-full flex-1"} defaultValue={tab}>
						<div className={"flex w-full items-center justify-center"}>
							<TabsList>
								<TabsTrigger value={"runtime"}>Runtime</TabsTrigger>
								<TabsTrigger value={"styling"}>Styling</TabsTrigger>
							</TabsList>
						</div>
						<TabsContent className={"flex-1"} value={"runtime"}>
							<RuntimeDetailsCard />
						</TabsContent>
						<TabsContent className={"flex-1"} value={"styling"}>
							<DevStylingTab />
						</TabsContent>
					</Tabs>
				</div>
			</Container>
		</Page>
	)
}
